import './StatusCommand.scss'

import IIncidentOverview from './../../../common/interfaces/incidentOverview/IIncidentOverview'
import IIncidentOverviewPeriod from '../../../common/interfaces/incidentOverview/IIncidentOverviewPeriod'


type ComponentProps = {
  incidentOverview?: IIncidentOverview
  handleActiveUserGuideTopicNameChangeRequest: (request:string) => void
}

const StatusCommand = (props:ComponentProps) => {

  // Get objects.
  var defaultPeriod:IIncidentOverviewPeriod|undefined = props.incidentOverview?.status.detailedAnalysis.userIncidentScores?.periods[0]
  var averedgeFlippedDefaultPeriod:number = 0

  if (defaultPeriod) {
    averedgeFlippedDefaultPeriod = 
      ((
        (defaultPeriod?.comparedUsers[0].reactionScore ? defaultPeriod?.comparedUsers[0].quantityScore : 0) + 
        (defaultPeriod?.comparedUsers[0].quantityScore ? defaultPeriod?.comparedUsers[0].reactionScore : 0) + 
        (defaultPeriod?.comparedUsers[0].severityScore ? defaultPeriod?.comparedUsers[0].severityScore : 0)
      ))
    averedgeFlippedDefaultPeriod = Math.round(averedgeFlippedDefaultPeriod / 3)
  }

  return (
    <div id='status-command' className={'status-style-' + averedgeFlippedDefaultPeriod} title='Din aktuelle score'> 
      {averedgeFlippedDefaultPeriod + '/10'} 
    </div>  
  )
}

export default StatusCommand
